/**
 * @generated SignedSource<<83cbd9f5e368eda790a8ddf517334f28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditMultipleChoiceElementV2Input = {
  answerOptions: ReadonlyArray<AnswerOptionV2Input>;
  answeringType: string;
  answeringTypeText?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  imageIdOpt?: string | null | undefined;
  multipleChoiceElementId: string;
  question: string;
  title: string;
};
export type AnswerOptionV2Input = {
  answer: string;
  imageRef?: string | null | undefined;
  isCorrect: boolean;
};
export type MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation$variables = {
  input: EditMultipleChoiceElementV2Input;
};
export type MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly editMultipleChoiceElement: {
        readonly multipleChoiceElement: {
          readonly " $fragmentSpreads": FragmentRefs<"MultipleChoiceElementForm_MultipleChoiceElementV2Fragment">;
        };
      } | null | undefined;
    };
  };
};
export type MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation = {
  response: MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation$data;
  variables: MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditMultipleChoiceElementV2Payload",
                "kind": "LinkedField",
                "name": "editMultipleChoiceElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementV2",
                    "kind": "LinkedField",
                    "name": "multipleChoiceElement",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "MultipleChoiceElementForm_MultipleChoiceElementV2Fragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElearningV2AdminMutationSchema",
            "kind": "LinkedField",
            "name": "ElearningV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditMultipleChoiceElementV2Payload",
                "kind": "LinkedField",
                "name": "editMultipleChoiceElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementV2",
                    "kind": "LinkedField",
                    "name": "multipleChoiceElement",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answeringType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerOptionV2",
                        "kind": "LinkedField",
                        "name": "answerOptions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "answer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isCorrect",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbe75ca3b938e22cbbb42bb113892818",
    "id": null,
    "metadata": {},
    "name": "MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation",
    "operationKind": "mutation",
    "text": "mutation MultipleChoiceElementForm_EditMultipleChoiceElementV2Mutation(\n  $input: EditMultipleChoiceElementV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      editMultipleChoiceElement(input: $input) {\n        multipleChoiceElement {\n          ...MultipleChoiceElementForm_MultipleChoiceElementV2Fragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment MultipleChoiceElementForm_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  id\n  title\n  question\n  image {\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    isCorrect\n    image {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a6e47e25932f2ae2b22eda30ea66dcb";

export default node;
